var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('certificate-default',{attrs:{"infocar":_vm.infocar,"prezzi-vendere":_vm.prezziVendere,"prezzi-comprare":_vm.prezziComprare,"prezzi-assicurare":_vm.prezziAssicurare,"type":_vm.type,"vehicle_type":_vm.vehicle_type}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c88a5f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/app/components/QuotationContainer.vue
// module id = wF0j
// module chunks = 1